import { GuidelineType, IGuideline } from '@domain/workspace';

export interface IGuidelineTooltipEvent {
    show: boolean;
    type: GuidelineType;
    trigger: GuidelineTrigger;
}

export interface IGuidelineSelection {
    instance?: IGuideline;
    hasMoved: boolean;
    isAdding: boolean;
}

export enum GuidelineTrigger {
    TOP,
    LEFT,
    RIGHT
}

export enum GuidelineColor {
    Black = 'rgba(0, 0, 0, 0.5)',
    Green = 'rgba(0, 128, 0, 0.5)',
    Magenta = 'rgba(229, 0, 125, 0.5)',
    Purple = 'rgba(128, 0, 128, 0.5)',
    White = 'rgba(255, 255, 255, 0.5)'
}

export const OldToNuiGuidelineColor = {
    [GuidelineColor.Black]: 'nui-black',
    [GuidelineColor.Green]: 'nui-green',
    [GuidelineColor.Magenta]: 'nui-red',
    [GuidelineColor.Purple]: 'nui-red',
    [GuidelineColor.White]: 'nui-white'
} as const;

export const NuiGuidelineColor = {
    'nui-black': '--nui-guidelines-guidelines-black',
    'nui-green': '--nui-guidelines-guidelines-green',
    'nui-red': '--nui-guidelines-guidelines-red',
    'nui-white': '--nui-guidelines-guidelines-white'
} as const;

export type NuiGuidelineColorName = keyof typeof NuiGuidelineColor;
